export default "__VITE_ASSET__95e36d7e__"